import type { OrderCharge } from "Order/Modules/Payment/Types/orderCharge";
import { atom } from "jotai";
import type {
	OrderFeeResponseDto,
	OrderPaymentDetailResponseDto,
} from "../../Infrastructure/Api/Api";

export const paymentDetailAtom = atom<OrderPaymentDetailResponseDto>();
export const chargesAtom = atom<OrderCharge[]>();
export const feesAtom = atom<OrderFeeResponseDto>();
